import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import template from './mass-edit.hbs'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import center from 'scoreboard/components/min-height-vertical-center-msg.hbs'
import DisplayHeader from 'scoreboard/components/display-header'
import EditableButton from 'scoreboard/components/editable-button'
import appDisplay from 'scoreboard/components/app-display'
import ChooseField from './choose-field'
import MassEditButtons from './mass-edit-buttons'
import MassEditForm from './mass-edit-form'
import MassEditResponse from './mass-edit-response'
import massEditFields from './mass-edit-fields'
import { massEditFieldsToColumns } from './mass-edit-fields'
import FilterWizard from 'scoreboard/reports/wizard/common/non-dataset-report-filter-wizard'
import ScorecardFilterMeta from 'scoreboard/reports/wizard/filter-meta/scorecard-filter-meta'
import massEditFilterExplanationBanner from './mass-edit-filter-explanation-banner.hbs'
import MassEditReportModel from './mass-edit-report-model'
import MassEditReportResults from './mass-edit-report-results'
import CurrentFiltersView from 'scoreboard/reports/common/current-filters'
import scrollContainer from 'scoreboard/components/scroll-container'
import PeriodDisplay from 'scoreboard/components/period-display'
import globals from 'scoreboard/components/globals'
import ForwardBackwardSizer from 'scoreboard/components/forward-backward-sizer'

/**
 * map of report filter types to corresponding report designer column types
 */
const filterToColumnType = {
	'label': 'label',
	'description' : 'description',
	'types': 'item-type',
	'value': 'actual',
	'dataTypes' : 'data-type',
	'updateTypes': 'update-type',
	'aggregationTypes': 'aggregation-type',
	'nativeCalendarIds':'calendar-id',
	'scoringTypeIds': 'scoring-type-id',
	'equation': 'equations',
	'missingValueTreatments':'missing-value-treatments',
	'owners':'owners',
	'updaters':'updaters',
	'weight':'weight',
	'score':'score',
	'tagIds':'tags',
	'colors':'color',
	'organizationIds' : 'organization',
	'start' : 'start',
	'archive' : 'archive',
	'precision' : 'precision',
	'unit' : 'unit',
	'currency' : 'currency-code',
	'rollupAggregationTypes': 'rollup-aggregation-type',
	'higherBetter': 'higher-better',
	'yesGood': 'yes-good'
}

const MassEdit = Backbone.View.extend({

	tagName: 'form',

	className: 'admin table-hack display-layout mass-edit',

	events: {
		'click .choose-field': 'onClickChooseField',
		'click .edit-selected-items': 'onClickEditSelectedItems',
		'click .reset-all': 'onClickResetAll',
		'change input[type=checkbox]': 'onCheckboxChange'
	},

	/**
	 * The Admin | Mass Edit screen
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 */
	initialize: function(options = {}) {
		this.options = options
		this.initializeReportModel()

		const MyFormView = FormView.extend({
			test: this.test.bind(this),
			validate: this.validate.bind(this)
		})
		this.formView = new MyFormView({
			el: this.el,
			guard: false
		})
		this.formView.on('change', this._change.bind(this))

		this.massEditButtons = new MassEditButtons(options)
		this.massEditFields = massEditFields()

		// #40707 calendar period selector
		this.periodDisplay = new PeriodDisplay({})
		this.periodDisplay.on('change:period', this.onChangePeriod.bind(this))
	},

	initializeReportModel: function() {
		this.model = new MassEditReportModel({})
		// #43464 apply a starting filter if navigating from scorecards-edit
		if (this.options.filter) {
			let value = this.options.filter.filterValue
			let key = this.options.filter.filterKey
			this.model.setFilter(value, key)
		}
		//the results expect an initial stream, so start with an empty array
		this.model.stream([])
		this.listenTo(this.model, 'change:filters', () => this.onChangeFilters())
		this.model.on('metadata', meta => {
			//all ids in the results are store in the meta so we don't have to load
			//the entire results to do the "select all" functionality.  whenever this
			//changes update what consists of all ids in the results
			this.allIds = _.get(meta, 'idsInResults', [])
			//if new results come in reset the selection
			this.selectedItemIds = []
			if (this.results) {
				this.results.toggleAll = false
			}
			this.massEditButtons.toggleEditSelectedItemsButton(false)
		})
	},

	render: function() {
		this.displayHeader = new DisplayHeader({
			heading: i18n.get('admin.massEdit'),
			mobileGearHidden: true
		})
		this.$el.empty().append(this.displayHeader.el, template())
		this.displayHeader.render()

		this.renderChooseFieldButton()
		this.currentFilters = this.filterView(this.$('.filters'), this.model).render()

		this.$('.mass-edit-buttons').replaceWith(this.massEditButtons.el)
		this.massEditButtons.render()

		this.toggleEmptyMessage()

		this.results && _.invoke(this.results, 'remove')
		this.results = new MassEditReportResults({
			model: this.model,
			parent: this,
			showQueryMetadata: true,
			isReport: true,
			el: this.$('.results'),
			scrollContainer: scrollContainer(this.el)
		})

		this.results.render()
		this.updateResultMetadata()

		this.$('.period-display').append(this.periodDisplay.el)
		this.periodDisplay.render()

		this.forwardBackwardSizer = new ForwardBackwardSizer({
			select: this.$('.dropdown .text'),
			controls: this.$('.period-display .backward-forward'),
			backward: this.$('.period-display .backward'),
			forward: this.$('.period-display .forward')
		}).render()

		this.formView.start()
		return this
	},

	renderChooseFieldButton: function() {
		this.chooseFieldButton = new EditableButton({
			el: this.$('.choose-field'),
			message: 'admin.massEdit.field.choose',
			label: this.getChooseFieldLabel()
		}).render()
	},

	renderResults: function() {
		let noField = _.isNil(this.selectedField)
		// check if the filters panel has no added filters
		let noFilters = this.$('.filter-badges').hasClass('no-filters')
		if (noField || noFilters) {
			return
		}

		this.model.editing = false
		this.model.fetch(this.model.fetchOptions)
	},

	updateResultMetadata: function() {
		if (this._metadataPromise) {
			return 	//if we're already waiting don't need to do anything futher
		}
		this._metadataPromise = this.model.resultsMetadata().then(meta => {
			delete this._metadataPromise
			if (this.currentFilters) {
				this.currentFilters.renderShowingXRecords(
					_.extend({maxResults: meta.totalCount}, meta))
			}
		})
	},

	filterView: function(el, model) {
		let view = new CurrentFiltersView({
			el,
			model,
			type: this.model.get('subtype'),
			showProjectSelector: true
		})
		view.on('addFilter', this.showAddFilterDialog.bind(this))
		return view
	},

	showAddFilterDialog: function() {
		this.wizard = new FilterWizard({
			meta: ScorecardFilterMeta,
			showProjectSelector: true
		})
		this.listenTo(this.wizard, 'done', (value, filterKey) => {
			this.model.setFilter(value, filterKey)
		})

		//clone the existing filters to prevent accidental modifications
		this.wizard.start({
			titlePrefixCode: 'admin.massEdit',
			filterExplanationTemplate: massEditFilterExplanationBanner,
			organizationId: this.model.get('organizationId'),
			filters: _.cloneDeep(this.model.get('filters')),
			section: 'scorecards',
			massEdit: true
		})
	},

	onClickChooseField: function() {
		let chooseField = new ChooseField({
			selectedField: this.selectedField
		})

		appDisplay.dialog(chooseField)
		chooseField.on('done', field => {
			this.selectedField = field
			this.chooseFieldButton.renderLabel(this.getChooseFieldLabel(), false)
			this.refreshMessagesAndResults()
		})
	},

	onChangePeriod: function(newPeriodId) {
		// update the global period id
		globals.periodId = newPeriodId
		// the report has built in handling of period changes
		this.model.trigger('change:relativePeriodId')
	},

	getChooseFieldLabel: function() {
		let label = _.get(this.selectedField, 'label')
		if (!_.isNil(label)) {
			return i18n.get(label)
		} else {
			return null
		}
	},

	onChangeFilters: function() {
		this.currentFilters.model = this.model
		this.currentFilters.render()
		this.refreshMessagesAndResults()
	},

	onClickEditSelectedItems: function() {
		// don't open mass edit dialog if we have information missing
		if (this.validate()) {
			return
		}

		this.massEditButtons.dialogOpening()

		// TODO - determination of showModifyWeightMessage
		let showModifyWeightMessage = false

		appDisplay.dialog($.get('api/tags'), globalTags => {
			const massEditForm = new MassEditForm({
				field: this.selectedField,
				scorecardItemIds: this.selectedItemIds,
				showModifyWeightMessage,
				globalTags
			})
			this.massEditButtons.dialogOpened()
			massEditForm.once('done', data => {
				this.massEditResponse = new MassEditResponse({data})
				this.$('.banner.mass-edit-response').removeClass('is-not-displayed')
					.html(this.massEditResponse.render().el)
				this.massEditResponse.scrollTo()
				this.massEditButtons.dialogComplete()
				this.renderResults()
			})
			massEditForm.on('cancel', () => {
				this.massEditButtons.dialogComplete()
			})
			return massEditForm
		})
	},

	refreshMessagesAndResults: function() {
		this.formView.clearErrors()
		this.updateColumns()
		this.toggleEmptyMessage()
		this.$('.banner.mass-edit-response').empty().addClass('is-not-displayed')
		this.renderResults()
	},

	toggleEmptyMessage: function() {
		let emptyMessage
		let noField = _.isNil(this.selectedField)
		// check if the filters panel has no added filters
		let noFilters = this.$('.filter-badges').hasClass('no-filters')
		let display = noField || noFilters
		if (noField) {
			emptyMessage = 'admin.massEdit.fields.noFields'
		} else if (noFilters) {
			emptyMessage = 'admin.massEdit.filters.noFilters'
		}
		this.$('.no-results').toggleClass('is-not-displayed', !display)
		this.$('.empty-message').empty().append(center(emptyMessage))
		this.$('.results').toggleClass('is-not-displayed', display)
	},

	updateColumns: function() {
		// default columns = ['id', 'label', 'organization']
		// (currently the id column is being replaced with checkbox)
		// followed by the column for the selected mass edit field,
		// then by any columns related to the selected filters
		let columns = new Set(this.model.defaultColumns)
		this.model.selectedField = this.selectedField
		if (this.selectedField) {
			let field = this.selectedField.value
			// get corresponding column for selected mass edit field
			// if we don't yet have a corresponding column, don't add it
			// the columns because it will blow up later in the process
			let column = this.columnFromMassEditField(field)
			if (!_.isNil(column)) {
				columns.add(column)
			}
		}

		let filters = _.get(this.model.attributes, 'filters')

		_.forOwn(filters, (value, key) => {
			if (!_.isEmpty(value)) {
				let potentialColumn = this.columnFromFilter(key)
				if (!_.isNil(potentialColumn)) {
					columns.add(potentialColumn)
				}
			}
		})

		this.model.resetStacks([], {silent:true})
		columns.forEach(col => {
			this.model.addStack(null, col, {transient: true, replace:true})
		})
	},

	columnFromFilter: function (filterKey) {
		return _.get(filterToColumnType, filterKey)
	},

	columnFromMassEditField: function (field) {
		return _.get(massEditFieldsToColumns, field)
	},

	onCheckboxChange: function() {
		this.formView.clearErrors()
	},

	onClickResetAll: function() {
		/* FIXME the 'reset all' button is currently commented out (#40651) and
		    this method will need to be implemented correctly as part of #39144
		 */
	},

	_change: function () {
		// #40712 disable "Edit Selected Items" button if no items are selected
		this.massEditButtons.toggleEditSelectedItemsButton(_.isEmpty(this.test()))
	},

	test: function() {
		// check to see if an item is selected
		if (!this.$('input:checkbox:checked').length) {
			return i18n.get('admin.massEdit.selectItem')
		}
		return FormView.prototype.test.apply(this, arguments)
	},

	validate: function () {
		let result = this.test()
		if (result) {
			this.formView.errorMessage(result)
		} else {
			this.formView.clearErrors()
		}
		return result
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.displayHeader,this.chooseFieldButton, this.massEditButtons,
			this.currentFilters, this.results, this.periodDisplay,
			this.forwardBackwardSizer], 'remove')
	}
})

export default MassEdit
MassEdit.__filename__ = 'admin/mass-edit/mass-edit.js'
